// extracted by mini-css-extract-plugin
export default {"colorSwatchList":"xmqOZtDt54uASMNAVn1D","colorSwatchLabel":"wrhX1LVPjIlbLIPkqQOM","customColorCheckbox":"cNeMYUGCV_Pfvrhcj316","colorSwatchText":"POqz18FLLQ09e_kLqZqh"};